import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { hlm } from 'app/core/utils/hlm';
import { ClassValue } from 'clsx';

@Component({
  selector: 'sheba-arrow-stick-small-icon',
  templateUrl: 'arrow-stick.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShebaArrowStickSmallIcon {
  readonly userClass = input<ClassValue>('', { alias: 'class' });
  readonly computedClass = computed(() => hlm('ltr:rotate-180 [[end]>&]:-scale-x-100', this.userClass()));
}
